export const buildSubmissionsExport = ({ items, headers, isMonthly, year, month }) => {
  const exportHeaders = headers.filter(header => header.value !== 'details')
  const keys = exportHeaders.map(header => header.value)
  const rows = items.filter(item => item.recruiterName)
  const data = rows.map(item => {
    const row = {}
    keys.forEach(key => {
      row[key] = item[key]
    })
    return row
  })

  if (data.length) {
    data.push({
      recruiterName: 'TOTAL',
      submissionsCount: rows.reduce((total, row) => total + (row.submissionsCount || 0), 0),
      interviewsCount: rows.reduce((total, row) => total + (row.interviewsCount || 0), 0),
      placementsCount: rows.reduce((total, row) => total + (row.placementsCount || 0), 0)
    })
  }

  const period = isMonthly
    ? `${year}-${String(month).padStart(2, '0')}`
    : year

  return {
    title: exportHeaders.map(header => header.text),
    key: keys,
    data,
    autoWidthFlag: true,
    filename: `Submissions ${period}`
  }
}
